<template>
    <div>
        <div class="vx-card__title">
            <h4 class="mb-4">Аналитика</h4>
        </div>
        <p v-if="!hasAnalytics" class="max-w-80">
            Здесь будут отображаться данные касательно прогресса рассылки, а также метрики доставки и прочтения сообщений
        </p>
        <ul v-else>
            <li class="mb-6">
                <IconWithStatistics
                    icon="LoaderIcon"
                    title="Обработано"
                    :count="getValue(analytics.processed)"
                    color="#C4C4C4"
                />
            </li>
            <li class="mb-6">
                <IconWithStatistics
                    icon="SendIcon"
                    title="Отправлено"
                    :count="getValue(analytics.sent)"
                    color="#F6D523"
                />
            </li>
            <li class="mb-6">
                <IconWithStatistics
                    icon="CheckIcon"
                    title="Прочитано"
                    :count="getValue(analytics.viewed)"
                    color="#28C76F"
                />
            </li>
            <li class="mb-6">
                <IconWithStatistics
                    icon="ArrowUpIcon"
                    title="Есть ответ"
                    :count="getValue(analytics.responded)"
                    color="#28C76F"
                />
            </li>
            <li class="mb-6">
                <IconWithStatistics
                    icon="AlertTriangleIcon"
                    title="Ошибка"
                    :count="getValue(analytics.errors)"
                    color="#EA5455"
                />
            </li>
        </ul>
    </div>
</template>
<script>
import IconWithStatistics from '@/pages/statistics/components/IconWithStatistics'

export default {
  components: {
    IconWithStatistics
  },
  props: {
    analytics: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasAnalytics () {
      return !['draft', 'under_moderation', 'declined'].includes(this.status)
    }
  },
  methods: {
    getValue (value) {
      return `${value} (${Math.trunc(value / this.analytics.receivers * 100)}%)`
    }
  }
}
</script>